import React from 'react';
import { Box } from '@tmap/mmm-style-guide/src/Box';
import { Divider } from '@tmap/mmm-style-guide/src/Divider';
import ColorBlocks from '../../../layouts/colorBlocks';
import BlankPreview from './blankPreview';

export function ContentBlock(props) {
  const {
    block,
    isPreview = false,
    isExamplePreview = false,
    index,
  } = props;
  const blockData = isExamplePreview ? block.componentPreviewProps : block.data;
  if (block.isValid && !block.isValid(blockData || {})) {
    return (
      isPreview ? <BlankPreview /> : null
    );
  }
  return (
    <ColorBlocks.Block overflow color={block.blockColor} spacing={block.blockSpacing || 'small'}>
      <block.Component {...blockData} isPreview={isPreview} blockIndex={index} />
    </ColorBlocks.Block>
  );
}

function ContentBlocks(props) {
  const {
    blocks,
    indexOffset = 0,
    isPreview = false,
    hideTopBorder = false,
    hideBottomBorder = false,
  } = props;

  const validBlocks = blocks.filter((block) => (
    !block.data.hidden && (block.isValid ? block.isValid(block.data) : true)
  ));
  if (validBlocks.length === 0) return null;
  return (
    <Box py={3}>
      {!hideTopBorder && !validBlocks[0].blockHideBorder && (
        <Divider sx={{ color: (theme) => theme.palette.grey[200] }} />
      )}
      {validBlocks.map((block, i) => (
        <ContentBlock block={block} isPreview={isPreview} index={i + indexOffset} key={i} />
      ))}
      {!hideBottomBorder && !validBlocks[validBlocks.length - 1].blockHideBorder && (
        <Divider sx={{ color: (theme) => theme.palette.grey[200] }} />
      )}
    </Box>
  );
}

export default ContentBlocks;
